module.exports = __webpack_public_path__ + "static/img/haizolAI.4102ff27.gif";